import React from 'react';
import Select from '../../../components/ui/Select';

const SortDropdown = ({ sortBy, onSortChange, resultsCount }) => {
  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'title_asc', label: 'A to Z' },
    { value: 'price_asc', label: 'Price: Low to High' },
    { value: 'price_desc', label: 'Price: High to Low' },
  ];

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="text-sm text-muted-foreground">
        Showing {resultsCount} courses
      </div>
      
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground hidden sm:block">Sort by:</span>
        <Select
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
          className="w-48"
        />
      </div>
    </div>
  );
};

export default SortDropdown;